module.exports = __webpack_public_path__ + "img/ingredienten-romige-citroenvis.9cb2ac9c.jpeg";